
import { Options, Vue } from 'vue-class-component';

@Options({
    props: {
        // msg: String
    },
    data() {
        return {
            isScrolled: false,
            isOpen: false
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.isScrolled = window.scrollY > 25; // Change 50 to the desired threshold value
        },
    },
})
export default class NavigationHeaderComponent extends Vue {
//   msg!: string
}
